import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { PresentationEditorLoading } from "@/components/presentations/editor/PresentationEditorLoading";

const PresentationEditorPage = lazy(
  () => import("@/components/presentations/editor/PresentationEditorPage"),
);

interface PresentationEditorSearch {
  id?: string;
  autogenerate?: string;
  templateId?: string;
}

export const Route = createFileRoute("/_authenticated/presentations/$id")({
  validateSearch: (search: Record<string, unknown>): PresentationEditorSearch => ({
    id: typeof search.id === "string" ? search.id : undefined,
    autogenerate: typeof search.autogenerate === "string" ? search.autogenerate : undefined,
    templateId: typeof search.templateId === "string" ? search.templateId : undefined,
  }),
  component: PresentationEditorRoute,
});

function PresentationEditorRoute() {
  return (
    <Suspense fallback={<PresentationEditorLoading />}>
      <PresentationEditorPage />
    </Suspense>
  );
}
